import React from "react";
import { Link } from "react-router-dom";
import { Bug, Sparkles } from "lucide-react";

/**
 * Footer — global site footer with legal + support links. Rendered
 * once at the bottom of App.js on pages that don't own the whole
 * viewport (i.e. not the studio takeover / TV app / director console).
 * Keep it lean: legal links, a "Report a bug" mailto, and a subtle
 * brand line.
 */
export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-black/60 text-white/60 text-xs mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
        <div className="inline-flex items-center gap-2 text-white/70">
          <Sparkles className="w-3.5 h-3.5 text-tv-accent" />
          <span className="font-black uppercase tracking-widest text-[10px]">Tap In TV Network</span>
          <span className="text-white/30">· © {year}</span>
        </div>
        <nav className="flex flex-wrap items-center gap-x-4 gap-y-1">
          <Link to="/terms"   data-testid="footer-terms"   className="hover:text-white">Terms</Link>
          <Link to="/privacy" data-testid="footer-privacy" className="hover:text-white">Privacy</Link>
          <Link to="/contact" data-testid="footer-contact" className="hover:text-white">Contact</Link>
          <a
            href="mailto:support@tapintvnetwork.com?subject=Bug%20report%20from%20Tap%20In%20TV"
            data-testid="footer-report-bug"
            className="hover:text-tv-accent inline-flex items-center gap-1"
          ><Bug className="w-3 h-3" /> Report a bug</a>
        </nav>
        <div className="sm:ml-auto text-white/30">Built for creators.</div>
      </div>
    </footer>
  );
}
